export enum EpiPageRouteKey {
  Start = 'Start',
  ContractAddonsFaq = 'Avtalstillval FAQ',
  ContractFaq = 'Avtal FAQ'
}
